import loadCustomer from './lib/load_customer';

export default class LoadCustomer {
  constructor(context) {
    this.context = context;
  }

  run(id) {
    if (this.context.stores.customers.has({ id })) {
      return;
    }
    loadCustomer(this.context, id);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/load_customer.js